// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7k-0";
export var startPickingButton = "_7k-1";